<div
  class="crowdctrl-form-input-field-wrap"
  [class.crowdctrl-form-input-field-wrap--invalid]="invalid"
>
  @if (isDatetimeLocalOutlineField()) {
    <ion-input
      [id]="dtPopoverTriggerId"
      class="input-fill-outline"
      readonly="true"
      [label]="effectiveLabel"
      fill="outline"
      [value]="datetimeLocalDisplayText"
      [placeholder]="effectivePlaceholder"
      [attr.required]="effectiveRequired"
      [attr.aria-label]="effectiveAriaLabel ?? null"
      [disabled]="isFieldDisabled"
      (ionFocus)="onIonFieldFocus($event)"
    ></ion-input>
    <ion-popover #dtPopover [trigger]="dtPopoverTriggerId" [keepContentsMounted]="true">
      <ng-template>
        <ion-datetime
          presentation="date-time"
          [locale]="nativeDateLangBcp47"
          [hourCycle]="'h12'"
          [value]="datetimeLocalWireValue"
          [min]="min ?? undefined"
          [max]="max ?? undefined"
          [disabled]="isFieldDisabled"
          [showDefaultButtons]="true"
          (ionChange)="onIonDatetimeChange($event)"
        ></ion-datetime>
      </ng-template>
    </ion-popover>
  } @else if (formControl) {
    <ion-input
      #ionField
      class="input-fill-outline"
      [formControl]="formControl"
      [type]="type"
      [attr.lang]="nativeDateInputLang ?? null"
      [label]="effectiveLabel"
      fill="outline"
      [placeholder]="effectivePlaceholder"
      [attr.required]="effectiveRequired"
      [attr.aria-label]="effectiveAriaLabel ?? null"
      [inputmode]="inputmode"
      [minlength]="minlength ?? null"
      [maxlength]="maxlength ?? null"
      [min]="min"
      [max]="max"
      [step]="step"
      [pattern]="pattern ?? ''"
      [name]="name"
      [autocomplete]="autocomplete"
      [autocapitalize]="autocapitalize"
      [autocorrect]="autocorrect"
      [enterkeyhint]="enterkeyhint"
      (ionInput)="ionInput.emit($event)"
      (ionChange)="ionChange.emit($event)"
      (ionBlur)="ionBlur.emit($event)"
      (ionFocus)="onIonFieldFocus($event)"
      (ionClear)="ionClear.emit($event)"
    ></ion-input>
  } @else {
    <ion-input
      #ionField
      class="input-fill-outline"
      [type]="type"
      [attr.lang]="nativeDateInputLang ?? null"
      [label]="effectiveLabel"
      fill="outline"
      [placeholder]="effectivePlaceholder"
      [attr.required]="effectiveRequired"
      [attr.aria-label]="effectiveAriaLabel ?? null"
      [disabled]="disabled"
      [inputmode]="inputmode"
      [minlength]="minlength ?? null"
      [maxlength]="maxlength ?? null"
      [min]="min"
      [max]="max"
      [step]="step"
      [pattern]="pattern ?? ''"
      [name]="name"
      [autocomplete]="autocomplete"
      [autocapitalize]="autocapitalize"
      [autocorrect]="autocorrect"
      [enterkeyhint]="enterkeyhint"
      (ionInput)="ionInput.emit($event)"
      (ionChange)="ionChange.emit($event)"
      (ionBlur)="ionBlur.emit($event)"
      (ionFocus)="onIonFieldFocus($event)"
      (ionClear)="ionClear.emit($event)"
    ></ion-input>
  }
  @if (hint) {
    <p class="crowdctrl-form-control-hint">{{ hint }}</p>
  }
</div>
